require('devbridge-autocomplete');
require('./autocomplete.less');
require('../m-scrollbar-default/m-scrollbar-default');
/**
 * @type EvEmitter
 */
import events from '../../modules/events';

jQuery(function() {
    const autocompleteParams = {
        cities: {
            lookup: [] // deprecated
        },
        location: {
            lookup: function(query, done) {
                $.post(
                    '/ajax/action/location/search/',
                    {
                        query: query
                    },
                    function(result) {
                        let items = {
                            suggestions: []
                        };
                        if (result.message == 'ok') {
                            result.data.forEach(function(item) {
                                items.suggestions.push({
                                    data: item,
                                    value: item.name
                                });
                            });
                        }
                        done(items);
                    }
                );
            },
            onSelect: function(suggestion) {
                suggestion.data.element = this;
                events.emitEvent('setLocation', [suggestion.data]);
            },
            triggerSelectOnValidInput: false,
            minChars: 3,
            showNoSuggestionNotice: true,
            noSuggestionNotice: 'Город не найден'
        }
    };

    let setAutocomplete = function($items) {
        $items.each(function() {
            let $this = $(this);

            let lookupParam = $this.data('autocompelte-source');

            let options = {
                minChars: 1,
                additionalContainerClass: '.mCSB_container',
                appendTo: $this.parent(),
                onSearchComplete: function() {
                    $('.autocomplete-suggestions').mCustomScrollbar({
                        axis: 'y',
                        scrollbarPosition: 'inside',
                        advanced: {
                            updateOnContentResize: true
                        },
                        live: true
                    });
                }
            };

            // isObject http://stackoverflow.com/a/14706877
            if (autocompleteParams[lookupParam] === Object(autocompleteParams[lookupParam])) {
                options = Object.assign({}, options, autocompleteParams[lookupParam]);
            }

            $this.autocomplete(options);
        });
    };

    setAutocomplete($('.js-autocomplete'));

    module.exports.setAutocomplete = setAutocomplete;
});



// WEBPACK FOOTER //
// ./blocks/autocomplete/autocomplete.js